import { render, staticRenderFns } from "./QADetail.vue?vue&type=template&id=a6a713ca"
import script from "./QADetail.vue?vue&type=script&lang=js"
export * from "./QADetail.vue?vue&type=script&lang=js"
import style0 from "./QADetail.vue?vue&type=style&index=0&id=a6a713ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports